<template>
  <b-modal
    no-close-on-backdrop
    no-close-on-esc
    size="md"
    :id="idModal"
    :title="titleModal"
    :ok-title="labelBtnOk"
    ok-variant="success"
    cancel-variant="secondary"
    cancel-title="Cancelar"
    @ok.prevent="validateForm"
    @cancel="$emit('cancel')"
    @close="$emit('cancel')"
  >
    <validation-observer ref="refFormData">
      <b-form @submit.prevent>
        <b-row>
          <b-col cols="12" class="mb-1">
            <b-form-group label="UUID" label-for="uuid">
              <b-form-input
                v-model="dataForm.uuid"
                id="uuid"
                placeholder="Deixe em branco para gerar automaticamente"
              />
              <small class="text-muted">Identificador único do parâmetro (opcional)</small>
            </b-form-group>
          </b-col>

          <b-col cols="12" class="mb-1">
            <b-form-group label="Descrição" label-for="parametro_descricao">
              <validation-provider #default="{ errors }" name="Descrição" rules="required">
                <b-form-input
                  v-model="dataForm.parametro_descricao"
                  id="parametro_descricao"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Ex: INTEGRACAO_TOTVS"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12" class="mb-1">
            <b-form-group label="Valor" label-for="parametro_valor">
              <validation-provider #default="{ errors }" name="Valor" rules="required">
                <b-form-input
                  v-model="dataForm.parametro_valor"
                  id="parametro_valor"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Digite o valor"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BRow, BCol, BFormGroup, BFormInput, BForm,
} from 'bootstrap-vue';
import { required } from '@validations';

export default {
  components: {
    BModal, BButton, BRow, BCol, BFormGroup, BFormInput, BForm,
    ValidationProvider, ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({ uuid: '', parametro_descricao: '', parametro_valor: '' }),
    },
    titleModal: { type: String, default: null },
    idModal: { type: String, default: null },
    labelBtnOk: { type: String, default: 'Adicionar' },
  },
  computed: {
    dataForm: {
      get() { return this.value; },
      set(v) { this.$emit('input', v); },
    },
  },
  methods: {
    async validateForm() {
      const valid = await this.$refs.refFormData.validate();
      if (!valid) return;
      this.$emit('ok', { ...this.dataForm });
      this.$bvModal.hide(this.idModal);
      this.dataForm = { uuid: '', parametro_descricao: '', parametro_valor: '' };
    },
  },
};
</script>
